export default __webpack_public_path__ + "static/media/D2.325fe179.svg";